import RetryIcon from "../images/retry.svg?react";

/**Default: 22px by 22px */
export default function CoreRetryIcon({
	height = 22,
	width = 22,
	color = "#42296E",
}: {
	width?: string | number;
	height?: string | number;
	/**@default "#42296E" */
	color?: string;
}) {
	return <RetryIcon width={width} height={height} color={color} />;
}
